<template>
  <a-modal :open="open" @cancel="cancelAction" class="modal-no-padding">
    <div class="modal-no-padding__header">
      <h2>Закрыть без сохранения?</h2>
    </div>
    <a-divider style="margin: 16px 0" />
    <div class="modal-no-padding__body">
      Если закрыть вкладку сейчас, заполненные данные не сохранятся.
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
          <a-row justify="end" :gutter="8">
            <a-col>
              <a-button class="secondary-button" @click="cancelAction">Вернуться</a-button>
            </a-col>
            <a-col>
              <a-button class="secondary-button" @click="closeAction">Закрыть</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>

export default {
  props: {
    open: Boolean,
  },
  emits: ['cancel', 'close'],
  setup(props, context) {
    const closeAction = () => {
      context.emit('close');
    }

    const cancelAction = () => {
      context.emit('cancel');
    }

    return {
      closeAction,
      cancelAction
    }
  }
}
</script>

<style scoped lang="scss">

</style>